import React, {useEffect, useState} from "react";
import Container from "@mui/material/Container";
import {Head, Loading} from "../../components";
import {Box, Tooltip} from "@mui/material";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import ReactPaginate from "react-paginate";
import IconButton from "@mui/material/IconButton";
import SyncIcon from "@mui/icons-material/Sync";
import moment from "moment-jalaali";
import {useDispatch, useSelector} from "react-redux";
import Api from "../../utils/api";
import {useNavigate} from "react-router";
import {useLocation} from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Divider from "@mui/material/Divider";
import SunEditor, {buttonList} from "suneditor-react";
import DialogActions from "@mui/material/DialogActions";
import {toast} from "react-toastify";
import MarketerList from "../../components/marketerList/marketerList";
import TemplateList from "../../components/templateList/templateList";
import reactStringReplace from 'react-string-replace';
import queryString from 'query-string';

const Contract = () => {

    const history = useNavigate();
    const location = useLocation();

    const query = queryString.parse(location.search);
    const [params, setParams] = useState({
        page: query.page ? parseInt(query.page) : 1,
        limit: query.limit ? parseInt(query.limit) : 100,
        status:query.status ? parseInt(query.status) : 0,
        parent_id: query.parent_id ? parseInt(query.parent_id) : '',
        name: query.name ? query.name : '',
        username:query.username ? query.username : '',
        national_code: query.national_code ? query.national_code : '',
        mobile: query.mobile ? query.mobile : '',
    });
    const [loading, setLoading] = useState(true);
    const [contract, setContract] = useState([]);
    const [ShowImg, setShowImg] = useState(false);
    const [img, setImg] = useState('')
    const [open, setOpen] = React.useState(false);
    const [form, setForm] = React.useState(false);
    const [searchTime, setSearchTime] = useState("");
    const [template, setTemplate] = useState(null);
    const [variable, setVariable] = useState({});


    const handleSubmit = (event) => {
        event.preventDefault();

        let obj = {
            "form": "assign_store",
            "marketer_id": form.marketer_id,
            "template_id": template.id,
            "custom_messages": {
                "_1_": "سَهَند",
                "_2_": "عَبدُاللّه"
            }
        }

        setLoading(true);
        new Api().post('/marketers/contract/assign', obj, false).then((response) => {
            if (typeof response !== "undefined") {
                if (response.status) {
                    toast.success(response.msg);
                } else {
                    toast.error(response.msg);
                }
            }
            setOpen(false);
            setLoading(false);
        })

    }

    const handleClickOpen = (id) => {
        setOpen(true);
        setTemplate(id)
    };
    const handleClose = () => {
        setOpen(false);
        setTemplate(null)

    };

    const handleContract = () => {
        new Api().get('/marketers/contract/list', {}).then((response) => {
            if (typeof response !== "undefined") {
                setContract(response);
            }

            setLoading(false);
        })
    }

    useEffect(() => {
        handleContract()
    } ,[])

    useEffect(() => {


        setTimeout(() => {
            const element = document.querySelector('body');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }, 500);

    }, []);






    const _makeQueryStringParams = (type, value) => {

        let n_params = params;
        n_params.page = 1;

        switch (type) {
            case 'page':
                n_params.page = value;
                break;
        }

        // create url
        let url = '?';
        url += `page=${n_params.page}`;

        history(`/contract/${url}`);

    };

    const handleChangeElement = (name , value) => {
        let frm = {...form};

        const word = value;


        if (searchTime) {
            clearTimeout(searchTime)
        }
        let loop = setTimeout(()=> {

            frm[name] = word;
            setForm(frm);

        },50);

        setSearchTime(loop);


    };
    const renderInputs = () => {
        console.log("renderInputs")
    }

    const handleReplace = () => {
        let arr = template?.body
        for (let i = 0; i < 5; i++) {
            arr = arr?.replace(i.toString(), `<input value="${variable[`_${i}_`]}" name="_${i}_" onchange="renderInputs()"/>`)
        }
        return arr
    }

    const pageCount = Math.ceil(parseInt(contract?.details?.list?.total) / parseInt(contract?.details?.list?.per_page));

    return(
        <Container>
            <Head data={{ 'link': '/', 'title': ' قرارداد  بازاریاب ها', 'description': '' }} />

            <Box mb={2}>
                <Grid container alignItems="center" >
                    <Grid item xs={4} sm={6}>
                        <TextField
                            select
                            value={params.limit}
                            margin='dense'
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={(event) => _makeQueryStringParams('limit', event.target.value)}
                        >
                            <MenuItem  value="10">10</MenuItem>
                            <MenuItem  value="20">20</MenuItem>
                            <MenuItem  value="30">30</MenuItem>
                            <MenuItem  value="50">50</MenuItem>
                            <MenuItem  value="100">100</MenuItem>
                            <MenuItem  value="200">200</MenuItem>
                        </TextField>
                    </Grid>
                    <Grid item xs={8} sm={6}>
                        <ReactPaginate
                            previousLabel={'<'}
                            nextLabel={'>'}
                            breakLabel={'...'}
                            pageCount={pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={(selectedItem) => _makeQueryStringParams('page',selectedItem.selected + 1)}
                            containerClassName={'pagination'}
                            activeClassName={'active'}
                        />
                    </Grid>
                </Grid>
            </Box>
            <div style={{ display: 'flex', direction: 'row', justifyContent: 'flex-end'}}>


                <Tooltip title="سینک" onClick={() => handleContract()}>
                    <IconButton>
                        <SyncIcon />
                    </IconButton>
                </Tooltip>
            </div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth={true}
            >
                <form onSubmit={handleSubmit} className='animate__animated animate__fadeIn' encType="multipart/form-data">
                    <DialogTitle id="alert-dialog-title">افزودن قرارداد به بازاریاب</DialogTitle>
                    <DialogContent>
                        <Grid container spacing={2}>
                            <Divider />
                            <Grid item xs={12}>
                                <MarketerList label={'بازاریاب مورد نظر'} onChange={(e) => handleChangeElement("parent_id" , e.id)}/>
                            </Grid>

                            <Grid item xs={12}>
                                <TemplateList  label={"قالب مورد نظر"} onChange={(e) => setTemplate(e)}/>
                            </Grid>
                            <Divider/>

                            <div dangerouslySetInnerHTML={{__html:handleReplace() }}/>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} color="primary">
                            بستن
                        </Button>
                        <Button disabled={loading} type={'submit'} color="primary" autoFocus>
                            ارسال اطلاعات
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
            <div style={{ overflowX: 'auto'}}>
                <table className='table'>
                    <thead>
                    <tr>
                        <th>ردیف</th>
                        <th>آی دی بازاریابی</th>
                        <th>کد بازاریابی</th>
                        <th>خلاصه متن</th>
                        <th>تاریخ ایجاد</th>
                        <th>عملیات</th>
                    </tr>
                    </thead>
                    <tbody>
                    {contract?.details?.data?.map((item, index) => {
                        return(
                            <tr>
                                <td>{index + 1}</td>
                                <td>{item.marketer_id || "---"}</td>
                                <td>{item.marketer?.marketer_code || "---"}</td>
                                <td>{item.body?.substr(0,100) + " ... " || "---"}</td>
                                <td style={{ direction: 'ltr'}}>{moment(item.created_at).locale('fa').format('jYYYY/jMM/jDD HH:mm:ss')}</td>
                                <td>
                                    <Tooltip title="افزودن به بازاریاب" onClick={() => handleClickOpen(item.template_id)}>
                                        <IconButton>
                                            <ControlPointIcon/>
                                        </IconButton>
                                    </Tooltip>
                                    <Button onClick={() => history.push(`/contract/${item.id}`)} size={"small"} color={"primary"} variant={"outlined"}>مشاهده</Button>&nbsp;
                                </td>
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
            </div>
            <ReactPaginate
                previousLabel={'<'}
                nextLabel={'>'}
                breakLabel={'...'}
                pageCount={pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={(selectedItem) => _makeQueryStringParams('page',selectedItem.selected + 1)}
                containerClassName={'pagination'}
                activeClassName={'active'}
            />
            {loading && <Loading/>}
            <Dialog
                open={ShowImg}
                onClose={() => setShowImg(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <img style={{ borderRadius: 0, maxHeight: 300}} src={img}/>
            </Dialog>
        </Container>
    );

}

export default Contract;